import React from "react";
import WhyChooseUs from "../UI/WhyChooseUs";

const WhyChooseUsElevation = () => {
    const features = [
        {
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2Fwhy_choose_us%2FCustomizable_Designs.png?alt=media&token=0e31bab9-1127-4119-b83f-cb22fe3368de",
            title: "Customizable Designs",
            description:
                "",
        },
        {
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2Fwhy_choose_us%2FFast_Turnaround_Time.png?alt=media&token=c13b1ed5-5d2e-496c-89d7-9281d87aa4b3",
            title: "Fast Turnaround Time",
            description: "",
        },
        {
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2Fwhy_choose_us%2FHigh_Definition_Realism.png?alt=media&token=af107670-e3b0-4e3f-80b6-80bdb75fb383",
            title: "High-Definition Realism",
            description: "",
        },
        {
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2Fwhy_choose_us%2FPerfect_for_Approvals_and_Marketing.png?alt=media&token=8a0232a1-f4a6-4bbd-bbce-cc29d28fbea1",
            title: "Perfect for Approvals & Marketing",
            description: "",
        },
        {
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2Fwhy_choose_us%2FSeamless_Integration.png?alt=media&token=4b8fb366-8deb-4534-83fb-d8ac702aec40",
            title: "Seamless Integration",
            description: "",
        },
    ];

    return (
        <>
            <WhyChooseUs features={features} />
        </>
    );
};

export default WhyChooseUsElevation;
